import Consulting from '@/views/Consulting/Consulting.vue'
export default {
    path: '/consulting/',
    name: 'consulting',
    component: Consulting,
    children: [{
        path: 'strategy',
        name:'strategy',
        component: () => import('@/views/Consulting/modules/StrategyConsulting.vue'),
        meta:{
            title:'战略规划',
            activeMenu: 'strategy'
        }
    },{
        path: 'brand',
        name:'brand',
        component: () => import('@/views/Consulting/modules/BrandChange.vue'),
        meta:{
            title:'品牌改革',
            activeMenu: 'brand'
        }
    }]
}